const ARTWORK_UPLOAD_SUCCESS_MESSAGE = "Your artwork is uploaded successfully!";
const ARTWORK_CURRENT_MESSAGE = "Your current artwork";

export { ARTWORK_UPLOAD_SUCCESS_MESSAGE, ARTWORK_CURRENT_MESSAGE };
